import React from 'react';

const Footer = () => {
  return (
    <footer
      className="bg-forest text-cream py-12 border-t border-cream/20"
      style={{
        backgroundColor: "#4f5a33"
      }}>
      <div className="container-custom">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <h3 className="text-2xl font-serif font-bold mb-2">Mario Huerta Roman</h3>
            <p className="text-cream/70 font-light text-sm"></p>
          </div>
          
          <div className="flex space-x-8 mb-6 md:mb-0">
            <a href="#" className="text-cream/70 hover:text-cream transition-colors"></a>
            <a href="#" className="text-cream/70 hover:text-cream transition-colors"></a>
            <a href="#" className="text-cream/70 hover:text-cream transition-colors"></a>
          </div>
        </div>
        
        <div className="border-t border-cream/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream/50 font-light">
          <p>&copy; {new Date().getFullYear()} Dr. Mario Huerta Roman. All rights reserved.</p>
          <p className="mt-2 md:mt-0">Designed with care.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
